// extracted by mini-css-extract-plugin
export default {"container":"footer_container__tTpaG","sp":"footer_sp__wo6tF","pwbyimg":"footer_pwbyimg__YRCpG","terms":"footer_terms__BICCc"};